module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "bordered-card",
    attrs: {
      "id": "right_section"
    }
  }, [_c('v-toolbar', {
    staticClass: "grey lighten-4 elevation-0"
  }, [_c('v-toolbar-title', {}, [_vm._v("\n      Layout/Block Settings\n    ")])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Jumbotron Section\n          ")], 1), _vm._v(" "), _c('v-card', [_c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.jumbotron.enable, 'jumbotron/enable')
      }
    },
    model: {
      value: (_vm.settings.jumbotron.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.jumbotron, "enable", $$v)
      },
      expression: "settings.jumbotron.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('block', {
    attrs: {
      "items": _vm.jumbotron_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "jumbotron",
      "data": _vm.settings.jumbotron
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Information Section\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.info_section.enable, 'info_section/enable')
      }
    },
    model: {
      value: (_vm.settings.info_section.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.info_section, "enable", $$v)
      },
      expression: "settings.info_section.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('block', {
    attrs: {
      "items": _vm.info_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "info_section",
      "data": _vm.settings.info_section
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Introduction Section\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.intro_section.enable, 'intro_section/enable')
      }
    },
    model: {
      value: (_vm.settings.intro_section.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.intro_section, "enable", $$v)
      },
      expression: "settings.intro_section.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.intro_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "intro_section",
      "data": _vm.settings.intro_section
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" FAQ Section\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make FAQ Section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.faq.enable, 'faq/enable')
      }
    },
    model: {
      value: (_vm.settings.faq.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.faq, "enable", $$v)
      },
      expression: "settings.faq.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.faq_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "faq",
      "data": _vm.settings.faq
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Case Studies\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make Case Studies section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.case_studies.enable, 'case_studies/enable')
      }
    },
    model: {
      value: (_vm.settings.case_studies.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.case_studies, "enable", $$v)
      },
      expression: "settings.case_studies.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.casestudies_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "case_studies",
      "data": _vm.settings.case_studies
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-expansion-panel', [_c('v-expansion-panel-content', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('v-icon', {
    staticClass: "mr-2"
  }, [_vm._v("mdi-view-grid")]), _vm._v(" Footer Studies\n          ")], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-2 pb-3",
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "justify-end": true
    }
  }, [_c('v-list', {
    attrs: {
      "subheader": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Enable Footer Section")]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "text-xs-right"
  }, [_vm._v("Make section visible on landing page")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "pl-4 pt-2",
    attrs: {
      "xs3": ""
    }
  }, [_c('v-switch', {
    on: {
      "change": function($event) {
        return _vm.onChange(_vm.settings.footer.enable, 'footer/enable')
      }
    },
    model: {
      value: (_vm.settings.footer.enable),
      callback: function($$v) {
        _vm.$set(_vm.settings.footer, "enable", $$v)
      },
      expression: "settings.footer.enable"
    }
  })], 1)], 1), _vm._v(" "), _c('multiple-block', {
    attrs: {
      "items": _vm.footer_items,
      "submitData": _vm.submitData,
      "loading": _vm.loading,
      "type": "footer",
      "data": _vm.settings.footer
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cfbf695","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/admin/settings/Pages/landing.vue
// module id = 1676
// module chunks = 2